<div class="tooltip_wrapper" [class.tooltip_enabled]="tooltip">
  <span class="counter" [ngClass]="{'counter-error': total < count}">
    {{count | number }}/{{total | number}}
  </span>
    <!-- Tooltip (only rendered if text is provided) -->
  <span *ngIf="tooltip" class="tooltip_text">{{ tooltip }}</span>
</div>
